import { Component, OnInit } from "@angular/core";
import { environment } from "../../../environments/environment";
import esriRequest from "@arcgis/core/request";
import { MapService } from "../../view/services/map.service";
import { FormControl } from "@angular/forms";
import Graphic from "@arcgis/core/Graphic";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Field from "@arcgis/core/layers/support/Field";

@Component({
  selector: "app-add-layer",
  templateUrl: "./add-layer.component.html",
  styleUrls: ["./add-layer.component.css"],
})
export class AddLayerComponent implements OnInit {
  uploadStatus: string;
  portalUrl = environment.portalUrl;

  constructor(protected mapService: MapService) {}

  ngOnInit() {}

  uploadFile(e) {
    let fileName = e.target.value.toLowerCase().split(".");
    const type = fileName[1];
    fileName = fileName[0].replace("c:\\fakepath\\", "");
    this.uploadStatus = "Agregando: " + fileName + "." + type;
    let filetype, idObject;
    switch (type) {
      case "geojson":
        filetype = "geojson";
        idObject = "ObjectId";
        break;
      case "zip":
        filetype = "shapefile";
        idObject = "FID";
        break;
      case "csv":
        filetype = "csv";
        break;
      case "gpx":
        filetype = "gpx";
        break;
    }
    var params = {
      name: fileName,
      targetSR: this.mapService.getViewMap().spatialReference,
      maxRecordCount: 1000,
      enforceInputFileSizeLimit: true,
      enforceOutputJsonSizeLimit: true,
      generalize: true,
      maxAllowableOffset: 10,
      reducePrecision: false,
      numberOfDigitsAfterDecimal: 2,
    };
    const myContent = {
      filetype: filetype,
      publishParameters: JSON.stringify(params),
      f: "json",
    };
    const form = document.getElementById("uploadForm");
    var formData = new FormData();
    var file = e.target.files[0];
    formData.append("file", file);
    esriRequest(
      "https://www.arcgis.com/sharing/rest/content/features/generate",
      {
        query: myContent,
        body: formData,
        responseType: "json",
        method: "post",
      }
    )
      .then(
        function (response) {
          var layerName =
            response.data.featureCollection.layers[0].layerDefinition.name;
          this.addFileToMap(
            response.data.featureCollection,
            idObject,
            layerName
          );
          this.uploadStatus = "Agregado: " + layerName;
        }.bind(this)
      )
      .catch(
        function (error) {
          this.uploadStatus = "Error: " + error.message;
        }.bind(this)
      );
  }

  addFileToMap(features, idObject, layerName) {
    var sourceGraphics = [];
    var layers = features.layers.map(function (layer) {
      var graphics = layer.featureSet.features.map(function (feature) {
        var graph = Graphic.fromJSON(feature);
        return graph;
      });
      sourceGraphics = sourceGraphics.concat(graphics);
      var featureLayer = new FeatureLayer({
        objectIdField: idObject,
        source: graphics,
        fields: layer.layerDefinition.fields.map(function (field) {
          return Field.fromJSON(field);
        }),
      });
      return featureLayer;
    });
    layers[0].title = layerName;
    this.mapService.getViewMap().map.addMany(layers);
    this.mapService
      .getViewMap()
      .goTo(sourceGraphics)
      .catch(function (error) {
        if (error.name != "AbortError") {
          console.error(error);
        }
      });
    this.mapService.getViewMap().popup.defaultPopupTemplateEnabled = true;
  }
}
